import Typography from '@mui/material/Typography';

export default function DetailsHeader({children,...props}) {
    return (                
        <Typography variant="body1" color="secondary" sx={{fontWeight: "700"}} {...props}>{children}</Typography>
    )
}